import PropTypes from 'prop-types';
import { METRIC_TONES, MONITOR_STATUS, SENTIMENTS, VERDICT_TYPES } from './constants';

export const metricShape = PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    delta: PropTypes.string.isRequired,
    tone: PropTypes.oneOf(Object.values(METRIC_TONES)),
});

export const verdictShape = PropTypes.shape({
    type: PropTypes.oneOf(Object.values(VERDICT_TYPES)).isRequired,
    sentiment: PropTypes.oneOf(Object.values(SENTIMENTS)),
    should_notify: PropTypes.bool,
    headline: PropTypes.string,
    metrics: PropTypes.arrayOf(metricShape),
});

export const monitorShape = PropTypes.shape({
    monitor_id: PropTypes.string.isRequired,
    owner_id: PropTypes.string,
    organization_id: PropTypes.number,
    user_query: PropTypes.string.isRequired,
    schedule: PropTypes.string.isRequired,
    next_run_at: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(MONITOR_STATUS)).isRequired,
    claimed_at: PropTypes.string,
    latest_verdict: verdictShape,
    session_id: PropTypes.string.isRequired,
    active_run_id: PropTypes.string,
});
